import * as React from "react";
import { PageTitle } from "../../components/TitleBar/PageTitle";
import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import EnhancedTable from "../../components/EnhancedTable/EnhancedTable";
import { Organization } from "../../models/organization";
import Box from "@mui/material/Box";


const listHeaders = { "Name": "name", "S3 Bucket": "s3_report_folder", "Internal": "is_internal" };

const formatTableData = (organizations: Organization[]) => {
    const formattedOrgs: any[] = []
    organizations.forEach(org => {
        formattedOrgs.push({
            name: org.name,
            s3_report_folder: org.s3_report_folder,
            is_internal: org.internal
        });
    });
    return formattedOrgs;
}


export const OrganizationContainer = () => {
    return (
        <Box>
            <PageTitle pageTitle="Organizations" icon={faBuilding} />
            {/*<EnhancedTable*/}
            {/*    title=""*/}
            {/*    formatMethod={formatTableData}*/}
            {/*    selector={organizationListSelector}*/}
            {/*    selectable={false}*/}
            {/*    headers={listHeaders} />*/}
        </Box>
    )
}